export default "__VITE_ASSET__B_lw_$84__"